import readOnlyManager from './read-only-manager';

export default {
  readOnlyManager,
};
